import React from 'react';
import { Api, CloudOutlined } from '@mui/icons-material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

import XLSIcon from '@3.0/DataSourceTypeIcon/SourceIcons/XlsIcon';
import CSVIcon from '@3.0/DataSourceTypeIcon/SourceIcons/CsvIcon';
import DatabricksIcon from '@3.0/DataSourceTypeIcon/SourceIcons/DatabricksIcon';
import KobaiAPIIcon from './SourceIcons/KobaiAPIIcon';

type TMUIIconProps = OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
  muiName: string;
  className?: string;
};

type TDataSourceTypeIconProps = {
  dataSourceTypeId: number;
  iconProps?:
    | React.ImgHTMLAttributes<HTMLImageElement>
    | React.SVGProps<SVGSVGElement>
    | React.HTMLAttributes<HTMLSpanElement>
    | TMUIIconProps;
  variant?: 'light' | 'dark';
};

const DatabaseTypeIcon = (props?: React.HTMLAttributes<HTMLSpanElement>) => (
  <span
    {...props}
    data-testid="data-base-icon"
    className={'material-symbols-outlined data-source-type-icon ' + (props?.className || '')}
  >
    database
  </span>
);

const ApiIcon = (props: TMUIIconProps) => (
  <Api
    {...props}
    data-testid="api-icon"
    className={'data-source-type-icon ' + (props?.className || '')}
  />
);

const CloudCSVIcon = (props: TMUIIconProps) => (
  <CloudOutlined
    {...props}
    data-testid="cloud-CSV-icon"
    className={'data-source-type-icon ' + (props?.className || '')}
  />
);

const Icon = ({ dataSourceTypeId, iconProps, variant }: TDataSourceTypeIconProps) => {
  switch (dataSourceTypeId) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 8:
    case 12:
      return DatabaseTypeIcon(iconProps as React.HTMLAttributes<HTMLSpanElement>);

    case 11:
      return (
        <DatabricksIcon
          {...(iconProps as React.ImgHTMLAttributes<HTMLImageElement>)}
          className={'data-source-type-icon ' + (iconProps?.className || '')}
          variant={variant}
        />
      );

    case 5:
    case 9:
    case 14:
    case 15:
      return CloudCSVIcon(iconProps as TMUIIconProps);

    case 6:
      return (
        <CSVIcon
          {...(iconProps as React.ImgHTMLAttributes<HTMLImageElement>)}
          data-testid="csv-icon"
          className={'data-source-type-icon ' + (iconProps?.className || '')}
          variant={variant}
        />
      );
    case 13:
      return (
        <XLSIcon
          {...(iconProps as React.ImgHTMLAttributes<HTMLImageElement>)}
          data-testid="xls-icon"
          className={'data-source-type-icon ' + (iconProps?.className || '')}
        />
      );

    case 7:
      return ApiIcon(iconProps as TMUIIconProps);

    case 10:
      return (
        <KobaiAPIIcon
          {...(iconProps as React.ImgHTMLAttributes<HTMLImageElement>)}
          className={'data-source-type-icon ' + (iconProps?.className || '')}
          variant={variant}
        />
      );

    default:
      return null;
  }
};

function DataSourceTypeIcon({
  dataSourceTypeId,
  iconProps = {},
  variant = 'dark',
}: TDataSourceTypeIconProps) {
  try {
    return <Icon dataSourceTypeId={dataSourceTypeId} iconProps={iconProps} variant={variant} />;
  } catch (e) {
    console.warn('Error getting DataSourceTypeIcon -->', e);
    return null;
  }
}

export default DataSourceTypeIcon;
